import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import SearchApp from "@/components/SearchApp";

function App() {
  return (
    <div className="App dark">
      <SearchApp />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0f0f10",
            border: "1px solid #262626",
            color: "#fff",
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
